import React from "react";
import { Redirect } from "@reach/router";
import { notFoundPath } from "@routes";

export function RedirectToNotFound() {
  return <Redirect to={notFoundPath} />;
}
